module.exports = __webpack_public_path__ + "img/efficon.d629ad97.webp";